import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import HomePage from './pages/HomePage';
import ServicesPage from './pages/ServicesPage';
import PricingPage from './pages/PricingPage';
import HowItWorksPage from './pages/HowItWorksPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import BlogPage from './pages/BlogPage';
import BlogPostPage from './pages/BlogPostPage';
import QuotePage from './pages/QuotePage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsPage from './pages/TermsPage';
import NotFoundPage from './pages/NotFoundPage';
import AdminLoginPage from './pages/AdminLoginPage';
import AdminDashboardPage from './pages/AdminDashboardPage';
import AdminQuoteDetailsPage from './pages/AdminQuoteDetailsPage';
import AdminLanguagesPage from './pages/AdminLanguagesPage';
import AdminRatesPage from './pages/AdminRatesPage';
import AdminClientsPage from './pages/AdminClientsPage'; // NOWY IMPORT
import AdminRoute from './components/AdminRoute';
import ScrollToTop from './components/ScrollToTop';
import './App.css';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="app-container">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/uslugi" element={<ServicesPage />} />
            <Route path="/cennik" element={<PricingPage />} />
            <Route path="/jak-to-dziala" element={<HowItWorksPage />} />
            <Route path="/o-nas" element={<AboutPage />} />
            <Route path="/kontakt" element={<ContactPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogPostPage />} />
            <Route path="/wycena" element={<QuotePage />} />
            <Route path="/polityka-prywatnosci" element={<PrivacyPolicyPage />} />
            <Route path="/regulamin" element={<TermsPage />} />
            
            <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route element={<AdminRoute />}>
              <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
              <Route path="/admin/quotes" element={<AdminDashboardPage />} />
              <Route path="/admin/quotes/:id" element={<AdminQuoteDetailsPage />} />
              <Route path="/admin/languages" element={<AdminLanguagesPage />} />
              <Route path="/admin/rates" element={<AdminRatesPage />} />
              <Route path="/admin/clients" element={<AdminClientsPage />} /> {/* NOWA ŚCIEŻKA */}
              <Route path="/admin" element={<Navigate to="/admin/dashboard" replace />} />
            </Route>
            
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}
export default App;